module.exports = __webpack_public_path__ + "img/Hearder-02-m.cdcd717f.png";